import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetHealthSpecialtyEligibilityScriptParams,
	GetHealthSpecialtyEligibilityScript,
	GetHealthSpecialtyEligibilityScriptResponse,
} from 'domain/usecases';
import {APIError} from 'data/errors/api-error';

export class RemoteGetHealthSpecialtyEligibilityScript implements GetHealthSpecialtyEligibilityScript {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHealthSpecialtyEligibilityScriptResponse>,
	) {}

	async get(
		params: GetHealthSpecialtyEligibilityScriptParams,
	): Promise<GetHealthSpecialtyEligibilityScriptResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal: params?.signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
